import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, OverlayTrigger, Popover, Row, Table } from 'react-bootstrap';
import { Info } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { calculateCreditLimitSuggestAmount, calculateReduceBalance } from '../../constants';
import NotyfContext from '../../contexts/NotyfContext';
import { blankCreditBuilder, fetchCreditBuilder, setIsDataSet } from '../../redux/slices/CreditBuilderSlice';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';
import IncreaseLimitModal from './IncreaseLimitsModal';
import InfoPopover from '../../components/new/InfoPopover';
import Joyride from 'react-joyride';
import { fetchTourProgresses, updateTourProgress } from '../../redux/slices/TourProgressSlice';
const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const CreditBuilder = ({ colSize, noWalkThrough }) => {
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: <>Calculate your score based on your ability to pay down your credit card balances</>,
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>Find out if how being behind on payments affects your scores!</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: <>Need more credit? Here are some great opportunities to increase your score FAST!</>,
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: <>Finally our recommendations on increasing your limits to help lower your balance to limit ratio without having to pay down your balances (meaning you can increase your score!).</>,
      disableBeacon: true,
    },
  ];
  // Tour Progresses
  const tourStatus = useSelector(state => state.tourProgress.status);
  const tours = useSelector(state => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === 'idle') dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (tours.filter(tour => tour.tour_name === 'credit-builder' && tour.completed).length === 0 && !noWalkThrough) setRun(true);
    else if (['loading', 'idle'].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);

  const handleJoyrideCallback = data => {
    const { type, status, index, action } = data;
    if (type === 'tour:end') dispatch(updateTourProgress({ tour_name: 'credit-builder', completed: 1 }));
  };

  colSize = colSize || 6;
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const creditBuilderData = useSelector(state => state.creditBuilder.creditBuilderData);
  const creditBuilderStatus = useSelector(state => state.creditBuilder.status);
  const creditBuilderError = useSelector(state => state.creditBuilder.error);
  const isDataSet = useSelector(state => state.creditBuilder.isDataSet);

  const [increaseLimitData, setIncreaseLimitData] = useState([]);

  const [backOnTrack, setBackOnTrack] = useState([]);
  const [reduceBalancesData, setReduceBalancesData] = useState([]);
  const [addMoreCredit, setAddMoreCredit] = useState([]);

  useEffect(() => {
    if (creditBuilderStatus === 'idle') {
      dispatch(fetchCreditBuilder());
    }
  }, [dispatch, creditBuilderStatus]);
  useEffect(() => {
    return () => {
      dispatch(setIsDataSet(0));
      dispatch(blankCreditBuilder());
    };
  }, []);
  useEffect(() => {
    if (creditBuilderData && Object.keys(creditBuilderData).length > 0) {
      if (creditBuilderData.error === 0 && isDataSet === 0) {
        dispatch(setIsDataSet(1));
        // dispatch(blankCreditBuilder());
        let reduce_balance = creditBuilderData.data.reduce_balance;
        let reduceBalancesDataOri = [];
        reduce_balance?.map(data => {
          let obj = {
            company: data.name,
            balance: data.total_balance,
            limit: eval(data.limit_calculate),
            payment: '',
            points: 0,
            total_limit: data.total_limit,
          };
          reduceBalancesDataOri.push(obj);
        });
        setReduceBalancesData(reduceBalancesDataOri);

        //set back on track
        let getBackOnTrack = creditBuilderData.data.back_on_track;
        let backOnTrackOri = [];
        getBackOnTrack?.map(data => {
          let obj = {
            company: data.name,
            loanType: data.type,
            pastDue: data.past_due,
            pay: 0,
            point: 0,
            score: data.score,
          };
          backOnTrackOri.push(obj);
        });
        setBackOnTrack(backOnTrackOri);

        //add more credit
        let addMoreCreditData = creditBuilderData.data.add_more_credit;
        let addMoreCreditOri = [];
        addMoreCreditData?.map(data => {
          let obj = {
            name: data.name,
            logo: data.account_logo,
            link: data.link,
            // link:"http://www.google.com",
            minimum_deposit: data.minimum_deposit,
            potential_increase: data.potential_increase,
          };
          addMoreCreditOri.push(obj);
        });
        setAddMoreCredit(addMoreCreditOri);

        //limit increse
        let increseLimit = creditBuilderData.data.limit_increase;
        let increseLimitOri = [];
        increseLimit?.map(data => {
          let obj = {
            company: data.name,
            limit: data.total_limit,
            link: data.link,
            // link:"http://www.google.com"
          };
          increseLimitOri.push(obj);
        });
        setIncreaseLimitData(increseLimitOri);
      }
    }
  }, [creditBuilderData]);
  if (creditBuilderStatus === 'loading') {
    return <Loader />;
  }
  if (creditBuilderStatus === 'failed') {
    notyf.open({
      type: 'danger',
      message: creditBuilderError,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }

  const getStepValue = (balance, payment) => {
    const maxStep = balance < 100 ? 5 : balance < 250 ? 10 : 20;
    const maxPayment = Math.floor(balance / maxStep) * maxStep;

    if (payment === maxPayment && payment < balance) {
      return 1;
    } else {
      return maxStep;
    }
  };

  return (
    <React.Fragment>
      <Helmet title='Credit Builder' />
      <style>
        {`
tbody {
    border: none;
}
th {
    font-size: 14px;
    font-weight: normal;
    color: var(--bs-light-gray);
    font-family: 'Anek Bangla', sans-serif !important;
    text-align: center;
}
td {
    text-align: center;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}

tr:last-child td {
    border: none;
}


/* Change the button background color */
.react-joyride__tooltip button {
  background-color: #0076FF !important; /* Change this to your desired color */
  border-color: #0076FF !important; /* Change this to your desired color */
}

/* Change the button hover background color */
.react-joyride__tooltip button:hover {
  background-color: #1b1848 !important; /* Change this to your desired hover color */
  border-color: #0076FF !important; /* Change this to your desired hover color */
}

/* Change the button properties */
.react-joyride__tooltip button[type="button"][data-action="back"] {
  appearance: none !important;
background-color: transparent !important;
border-style: none !important;
color: #0076FF !important;
cursor: pointer !important;
font-family: "Anek Bangla", sans-serif !important;
font-size: 16px !important;
font-weight: 400 !important;
line-height: 16px !important;
margin: 0 !important;
margin-right: auto !important;
padding: 8px !important;
text-align: center !important;
text-transform: none !important;
visibility: visible !important;


}

/* Change the button hover properties */
button[type="button"][data-action="back"]:hover {
 color: var(--bs-dark-blue) !important; 
  background-color: none !important; 
  
}

div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
  /* Override the style here */
  flex: inherit !important;
}
          `}
      </style>
      <Container fluid className='p-0 container-fluid-1335'>
        <Joyride showSkipButton={true} locale={{ last: 'FINISH' }} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={false} hideCloseButton disableOverlayClose={true} disableCloseOnEsc={true} callback={handleJoyrideCallback} />
        <Row>
          <Col md={colSize} className='mb-4'>
            <Card className='shadow border-0 p-4 mb-0  rounded-3  h-100 overflow-x-auto first-step'>
              <Card.Header className='border-0 bg-white d-flex align-items-center' style={{ height: '40px' }}>
                <h4 className='mb-0 lh-1'>Reduce Balances</h4>
                <InfoPopover headerContent='Reduce Balances' bodyContent='Please note that the suggested payment amounts and estimated credit score increases provided in this section are for informational purposes only and should not be taken as financial advice. We are simply providing a guide to assist you in making decisions about your credit balance. You are solely responsible for any decisions you make regarding your credit accounts. Please keep in mind that credit scores are complex and can be influenced by various factors beyond the balance of your credit card, so our estimates may not always be accurate. Additionally, we use our own credit scoring algorithm based on the cases of other clients, which may not be the same as the scoring models used by credit bureaus. Please consult with a financial advisor or credit counseling agency before making any significant changes to your credit accounts.' />
              </Card.Header>

              <Card.Body className='py-1'>
                <Table className='mb-0'>
                  <thead className='border-0'>
                    <tr>
                      <th>Company</th>
                      <th>Balance</th>
                      <th>Limit</th>
                      <th>Paying This</th>
                      <th>Potential Increase</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='border-0'>
                    {reduceBalancesData.length > 0 ? (
                      <>
                        {reduceBalancesData.map((reduceBalance, index) => (
                          <tr key={index}>
                            <td dangerouslySetInnerHTML={{ __html: reduceBalance.company }}></td>
                            <td>${parseFloat(reduceBalance.balance?.toString()?.replace(',', ''))?.toLocaleString()}</td>
                            <td>${parseFloat(reduceBalance.total_limit?.toString()?.replace(',', ''))?.toLocaleString()}</td>
                            <td style={{ width: '120px' }}>
                              <Button variant='light' type='button' className='bg-white border border-2 rounded-3 w-100 d-flex align-items-center outline-none justify-content-center' disabled={reduceBalance.balance === 0}>
                                $
                                <input
                                  type='number'
                                  style={{
                                    outline: 'unset',
                                    width: '90%',
                                    border: '0px none',
                                    textAlign: 'center',
                                    minWidth: '100px',
                                  }}
                                  min='0'
                                  max={reduceBalance.balance}
                                  step={reduceBalance.balance < 100 ? '5' : reduceBalance.balance < 250 ? '10' : reduceBalance.balance < 500 ? '20' : '50'}
                                  placeholder='0'
                                  pattern='\d*'
                                  onInput={e => (e.target.value = e.target.value.replace(/[^\d,]/g, ''))}
                                  disabled={reduceBalance.balance === 0}
                                  onChange={e => {
                                    let value = parseInt(e.target.value.replace(/,/g, ''));
                                    const currentStep = reduceBalance.balance < 100 ? 5 : reduceBalance.balance < 250 ? 10 : reduceBalance.balance < 500 ? 20 : 50;

                                    if (value > reduceBalance.balance) {
                                      value = reduceBalance.balance;
                                      e.target.value = numberWithCommas(value); // Use the numberWithCommas function here
                                    }

                                    e.target.step = value + currentStep > reduceBalance.balance && value < reduceBalance.balance ? 1 : currentStep;
                                    setReduceBalancesData(reduceBalancesData.map((balance, ind) => (ind === index ? { ...balance, payment: value } : balance)));
                                  }}
                                />
                              </Button>
                            </td>

                            <td>+ {reduceBalance.points} Points</td>
                            <td>
                              <Button variant='primary' disabled={reduceBalance.balance === 0} onClick={() => setReduceBalancesData(reduceBalancesData.map((balance, ind) => (ind == index ? { ...balance, points: calculateReduceBalance(balance.limit, balance.payment) } : balance)))}>
                                Calculate
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td align='center' colSpan={6}>
                          You do not have any active revolving credit cards currently reporting!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md={colSize} className='mb-4'>
            <Card className='shadow border-0 p-4 mb-0 rounded-3 h-100 overflow-x-auto second-step'>
              <Card.Header className='border-0 bg-white d-flex align-items-center' style={{ height: '40px' }}>
                <h4 className='mb-0 lh-1'>Get Back On Track</h4>

                <InfoPopover headerContent='Get Back On Track' bodyContent='Please note that the suggested payment amounts and estimated credit score increases provided in this section are for informational purposes only and should not be taken as financial advice. We are simply providing a guide to assist you in making decisions about your past due accounts. You are solely responsible for any decisions you make regarding your credit accounts. Please keep in mind that credit scores are complex and can be influenced by various factors beyond paying past due accounts, so our estimates may not always be accurate. Additionally, we use our own credit scoring algorithm based on the cases of other clients, which may not be the same as the scoring algorithm based on the cases of other clients, which may not be the same as the scoring models used by credit bureaus' />
              </Card.Header>
              <Card.Body className='py-1'>
                <Table className='mb-0'>
                  <thead className='border-0'>
                    <tr>
                      <th>Company</th>
                      <th>Loan Type</th>
                      <th>Past Due</th>
                      {/* <th>If You Pay</th> */}
                      <th>Potential Damage</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody className='border-0'>
                    {backOnTrack.filter(e => e.pastDue != 0).length ? (
                      <>
                        {backOnTrack?.map((data, index) => {
                          return (
                            <tr>
                              <td dangerouslySetInnerHTML={{ __html: data.company }}></td>
                              <td>{data.loanType}</td>
                              <td className='text-danger'>$-{data.pastDue}</td>
                              <td>{data.score}</td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr>
                        <td align='center' colSpan={4}>
                          Good job! You are on track with your monthly payments!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md={colSize} className='mb-4'>
            <Card className='shadow border-0 p-4 mb-0  rounded-3 h-100 overflow-x-auto third-step'>
              <Card.Header className='border-0 bg-white d-flex align-items-center rounded-3 pt-3'>
                <h4 className='mb-0 lh-1'>Add More Credit</h4>
                <InfoPopover headerContent='Add More Credit' bodyContent='Please note that the suggestion to open a secured credit card provided in this section is for informational purposes only and should not be taken as financial advice. We are simply providing a guide to assist you in making decisions about building your credit. You are solely responsible for any decisions you make regarding your credit accounts. Please keep in mind that credit scores are complex and can be influenced by various factors beyond opening a secured credit card, so our estimates may not always be accurate. Additionally, we use our own credit scoring algorithm based on the cases of other clients, which may not be the same as the scoring models used by credit bureaus.' />
              </Card.Header>
              <Card.Body className='py-1'>
                <Table className='mb-0'>
                  <style>
                    {`

                    @media (max-width: 767px) {
  th {
    min-width: 140px;
  }
}

                    `}
                  </style>
                  <thead className='border-0'>
                    <tr>
                      <th>Company</th>
                      <th>Minimum Deposit</th>
                      <th>Potential Increase</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='border-0'>
                    {addMoreCredit.length > 0 ? (
                      <>
                        {addMoreCredit?.map(data => {
                          return (
                            <tr>
                              <td>{data.logo !== '' ? <img src={data.logo} alt='compamy logo' className='img-fluid' style={{ maxHeight: '30px', maxWidth: '140px' }} /> : data.name}</td>
                              <td>${parseFloat(data.minimum_deposit?.toString()?.replace(',', '')?.replace('$', ''))?.toLocaleString()}</td>
                              <td className='text-success'>40 to 60 Points</td>
                              <td>
                                <a href={data.link !== '' ? data.link : '#'} target='_blank' type='button' className='btn btn-primary'>
                                  Apply Now
                                </a>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr>
                        <td align='center' colSpan={4}>
                          Good job! You are on track with your monthly payments!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md={colSize} className='mb-4'>
            <Card className='shadow border-0 p-4 mb-0  rounded-3 h-100 overflow-x-auto  fourth-step'>
              <Card.Header className='border-0 bg-white d-flex align-items-center' style={{ height: '40px' }}>
                <h4 className='mb-0 lh-1'>Increase Limits</h4>
                <InfoPopover headerContent='Increase Limits' bodyContent='Please note that the suggested credit limit increases provided in this section are for informational purposes only and should not be taken as financial advice. Our Goal is to provide you with techniques that if done correctly along with minimizing credit card balances can in some cases help improve your credit score and standing.' />
              </Card.Header>

              <Card.Body className='py-1'>
                <Table className='mb-0'>
                  <thead className='border-0'>
                    <tr>
                      <th>Company</th>
                      <th>Limit</th>
                      <th>Suggested Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='border-0'>
                    {increaseLimitData.length > 0 ? (
                      increaseLimitData.map(increaseLimit => (
                        <tr>
                          <td dangerouslySetInnerHTML={{ __html: increaseLimit.company }}></td>
                          <td>${parseFloat(increaseLimit.limit?.toString()?.replace(',', ''))?.toLocaleString()}</td>
                          <td>$ {calculateCreditLimitSuggestAmount(increaseLimit.limit)?.toLocaleString()}</td>
                          <td>
                            <IncreaseLimitModal
                              trigger={
                                <a href={increaseLimit.link !== '' ? increaseLimit.link : void 0} className='btn btn-primary' target='_blank'>
                                  Learn More
                                </a>
                              }
                              heading={`More About Increasing Limits`}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td align='center' colSpan={4}>
                          You do not have any active revolving credit cards currently reporting!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default CreditBuilder;
